module.exports = __webpack_public_path__ + "img/Android.baf6d5ef.png";